<template>
  <div
    class="modal_wrap bottom_modal mobile_filter_modal"
    :class="{ on: show }"
    id="modal_wrap"
  >
    <div class="modal_inner" v-if="show" id="modal_inner">
      <div class="modal" ref="modal" id="filter_modal" @scroll="onScroll">
        <div class="close_txt">
          <p class="pnt" @click="close(false)">
            닫기<img
              :src="require('@/assets/front/images/i_x_pop_s.png')"
              alt=""
            />
          </p>
        </div>
        <div class="main_con">
          <div class="con_top_wrap">
            <div class="con_top" id="con_top" ref="con_top">
              <div class="con_title">
                필터 선택하기
              </div>
              <div class="con_tab_li">
                <ul>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_1' }"
                    id="tab_1"
                    @click="tabSel('tab_1')"
                  >
                    제조사
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_2' }"
                    id="tab_2"
                    @click="tabSel('tab_2')"
                  >
                    RAM
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_3' }"
                    id="tab_3"
                    @click="tabSel('tab_3')"
                  >
                    내장메모리
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_4' }"
                    id="tab_4"
                    @click="tabSel('tab_4')"
                  >
                    외장메모리
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_5' }"
                    id="tab_5"
                    @click="tabSel('tab_5')"
                  >
                    화면크기
                  </li>
                  <li
                    class="tab_li"
                    :class="{ on: filterSelTab == 'tab_6' }"
                    id="tab_6"
                    @click="tabSel('tab_6')"
                  >
                    배터리
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="con_section_wrap" ref="con_section_wrap">
            <div class="con_section pt" ref="tab_1" id="sec_1">
              <div class="sec_title">제조사<span>(중복선택가능)</span></div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in manufacturerTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectManufacturer"
                    @click="funSelectManufacturer(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div" ref="con_section_div"></div>
            <div class="con_section" ref="tab_2" id="sec_2">
              <div class="sec_title">RAM<span>(중복선택가능)</span></div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in ramTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectRam"
                    @click="funSelectRam(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div"></div>
            <div class="con_section" ref="tab_3" id="sec_3">
              <div class="sec_title">내장메모리<span>(중복선택가능)</span></div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in inMemoryTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectInMemory"
                    @click="funSelectInMemory(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div"></div>
            <div class="con_section" ref="tab_4" id="sec_4">
              <div class="sec_title">외장메모리<span>(중복선택가능)</span></div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in exMemoryTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectExMemory"
                    @click="funSelectExMemory(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div"></div>
            <div class="con_section" ref="tab_5" id="sec_5">
              <div class="sec_title">화면크기<span>(중복선택가능)</span></div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in screenTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectScreen"
                    @click="funSelectScreen(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
            <div class="con_section_div"></div>
            <div class="con_section" ref="tab_6" id="sec_6">
              <div class="sec_title">배터리<span>(중복선택가능)</span></div>
              <div class="sec_item">
                <label
                  v-for="(item, index) in batteryTypes"
                  :key="index"
                  class="pnt"
                >
                  <input
                    type="checkbox"
                    :name="item.name"
                    :value="item.value"
                    v-model="selectBattery"
                    @click="funSelectBattery(item.value)"
                  />
                  <div class="txt"></div>
                  <div class="txt02" :title="item.label">{{ item.label }}</div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="btm_btn">
          <div class="btn_wrap">
            <button class="btn bo pnt reset" @click.stop.prevent="reset">
              <i class="i_filter_reset"></i>필터 초기화
            </button>
            <button class="btn pnt" @click.stop.prevent="close(true)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        class="made_toast_layer_common"
        style="bottom:7rem;"
        v-if="isViewToast"
      >
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MobileFilter',
  description: '휴대폰 필터',
  props: {
    show: Boolean,
    filterSelTab: {
      type: String,
      default: 'tab_1',
    },
  },
  computed: {},
  data() {
    return {
      selectManufacturer: ['ALL'], // 선택한 값
      manufacturerTypes: [
        { name: 'manu_1', label: '전체', value: 'ALL' },
        { name: 'manu_2', label: '삼성', value: 'SAMSUNG' },
        { name: 'manu_3', label: '애플', value: 'APPLE' },
        { name: 'manu_4', label: '기타', value: 'ETC' },
      ],
      selectRam: ['ALL'], // 선택한 값
      ramTypes: [
        { name: 'ram_1', label: '전체', value: 'ALL' },
        { name: 'ram_2', label: '2GB', value: '2' },
        { name: 'ram_3', label: '3GB', value: '3' },
        { name: 'ram_4', label: '4GB', value: '4' },
        { name: 'ram_5', label: '6GB', value: '6' },
        { name: 'ram_6', label: '8GB', value: '8' },
        { name: 'ram_7', label: '12GB', value: '12' },
      ],
      selectInMemory: ['ALL'], // 선택한 값
      inMemoryTypes: [
        { name: 'inMemory_1', label: '전체', value: 'ALL' },
        { name: 'inMemory_2', label: '16GB', value: '16' },
        { name: 'inMemory_3', label: '32GB', value: '32' },
        { name: 'inMemory_4', label: '64GB', value: '64' },
        { name: 'inMemory_5', label: '128GB', value: '128' },
        { name: 'inMemory_6', label: '256GB', value: '256' },
        { name: 'inMemory_7', label: '512GB', value: '512' },
        { name: 'inMemory_8', label: '1TB', value: '1000' },
      ],
      selectExMemory: ['ALL'], // 선택한 값
      exMemoryTypes: [
        { name: 'exMemory_1', label: '전체', value: 'ALL' },
        { name: 'exMemory_2', label: '외장미지원', value: '0' },
        { name: 'exMemory_3', label: '32GB', value: '32' },
        { name: 'exMemory_4', label: '64GB', value: '64' },
        { name: 'exMemory_5', label: '128GB', value: '128' },
        { name: 'exMemory_6', label: '256GB', value: '256' },
        { name: 'exMemory_7', label: '512GB', value: '512' },
        { name: 'exMemory_8', label: '1TB 이상', value: 'O_1000' },
      ],
      selectScreen: ['ALL'], // 선택한 값
      screenTypes: [
        { name: 'screen_1', label: '전체', value: 'ALL' },
        { name: 'screen_2', label: '5인치 미만', value: 'U_5.0' },
        { name: 'screen_3', label: '5.0~5.9인치', value: 'B_5.0_5.9' },
        { name: 'screen_4', label: '6.0~6.4인치', value: 'B_6.0_6.4' },
        { name: 'screen_5', label: '6.5~6.9인치', value: 'B_6.5_6.9' },
        { name: 'screen_6', label: '7인치 이상', value: 'O_7.0' },
      ],
      selectBattery: ['ALL'], // 선택한 값
      batteryTypes: [
        { name: 'battery_1', label: '전체', value: 'ALL' },
        { name: 'battery_2', label: '2000mAh 미만', value: 'U_2000' },
        { name: 'battery_3', label: '2000~2999mAh', value: 'B_2000_2999' },
        { name: 'battery_4', label: '3000~3999mAh', value: 'B_3000_3999' },
        { name: 'battery_5', label: '4000~4999mAh', value: 'B_4000_4999' },
        { name: 'battery_6', label: '5000mAh 이상', value: 'O_5000' },
      ],
      isViewToast: false,
      errorMessage: '',
      fileterSelTab: this.filterSelTab,
    };
  },
  watch: {
    filterSelTab() {
      this.$nextTick(function() {
        this.tabSel(this.filterSelTab);
      });
    },
  },
  methods: {
    close(dataType) {
      if (dataType) {
        if (this.selectManufacturer.length < 1) {
          this.errorMessage = '제조사를 선택해주세요';
          this.toastView();
          return;
        }
        if (this.selectRam.length < 1) {
          this.errorMessage = 'RAM을 선택해주세요';
          this.toastView();
          return;
        }
        if (this.selectInMemory.length < 1) {
          this.errorMessage = '내장메모리를 선택해주세요';
          this.toastView();
          return;
        }
        if (this.selectExMemory.length < 1) {
          this.errorMessage = '외장메모리를 선택해주세요';
          this.toastView();
          return;
        }
        if (this.selectScreen.length < 1) {
          this.errorMessage = '화면크기를 선택해주세요';
          this.toastView();
          return;
        }
        if (this.selectBattery.length < 1) {
          this.errorMessage = '배터리를 선택해주세요';
          this.toastView();
          return;
        }
      }
      this.$emit(
        'close',
        dataType,
        this.selectManufacturer,
        this.selectRam,
        this.selectInMemory,
        this.selectExMemory,
        this.selectScreen,
        this.selectBattery,
      );
    },
    reset() {
      this.selectManufacturer.splice(0);
      this.selectManufacturer.push('ALL');

      this.selectRam.splice(0);
      this.selectRam.push('ALL');

      this.selectInMemory.splice(0);
      this.selectInMemory.push('ALL');

      this.selectExMemory.splice(0);
      this.selectExMemory.push('ALL');

      this.selectScreen.splice(0);
      this.selectScreen.push('ALL');

      this.selectBattery.splice(0);
      this.selectBattery.push('ALL');

      this.$refs.tab_1.scrollIntoView({ behavior: 'smooth' });
    },
    funSelectManufacturer(val) {
      const findManufacturer = this.selectManufacturer.findIndex(
        element => element == val,
      );

      console.log('findManufacturer = {}', findManufacturer);

      // 선택한 값이 없을 경우
      if (findManufacturer === -1) {
        // ALL일 경우
        if (val == this.manufacturerTypes[0].value) {
          this.selectManufacturer.splice(0);
        } else {
          const findAllManufacturer = this.selectManufacturer.findIndex(
            element => element == this.manufacturerTypes[0].value,
          );

          if (findAllManufacturer >= 0) {
            this.selectManufacturer.splice(findAllManufacturer, 1);
          }
        }

        this.selectManufacturer.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectManufacturer.splice(findManufacturer, 1);
      }
      console.log(this.selectManufacturer);
    },
    funSelectRam(val) {
      const findRam = this.selectRam.findIndex(element => element == val);

      console.log('findRam = {}', findRam);

      // 선택한 값이 없을 경우
      if (findRam === -1) {
        // ALL일 경우
        if (val == this.ramTypes[0].value) {
          this.selectRam.splice(0);
        } else {
          const findAllTelecom = this.selectRam.findIndex(
            element => element == this.ramTypes[0].value,
          );

          if (findAllTelecom >= 0) {
            this.selectRam.splice(findAllTelecom, 1);
          }
        }

        this.selectRam.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectRam.splice(findRam, 1);
      }
      console.log(this.selectRam);
    },
    funSelectInMemory(val) {
      const findInMemory = this.selectInMemory.findIndex(
        element => element == val,
      );

      console.log('findInMemory = {}', findInMemory);

      // 선택한 값이 없을 경우
      if (findInMemory === -1) {
        // ALL일 경우
        if (val == this.inMemoryTypes[0].value) {
          this.selectInMemory.splice(0);
        } else {
          const findAllInMemory = this.selectInMemory.findIndex(
            element => element == this.inMemoryTypes[0].value,
          );

          if (findAllInMemory >= 0) {
            this.selectInMemory.splice(findAllInMemory, 1);
          }
        }

        this.selectInMemory.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectInMemory.splice(findInMemory, 1);
      }
      console.log(this.selectInMemory);
    },
    funSelectExMemory(val) {
      const findExMemory = this.selectExMemory.findIndex(
        element => element == val,
      );

      console.log('findExMemory = {}', findExMemory);

      // 선택한 값이 없을 경우
      if (findExMemory === -1) {
        // ALL일 경우
        if (val == this.exMemoryTypes[0].value) {
          this.selectExMemory.splice(0);
        } else {
          const findAllExMemory = this.selectExMemory.findIndex(
            element => element == this.exMemoryTypes[0].value,
          );

          if (findAllExMemory >= 0) {
            this.selectExMemory.splice(findAllExMemory, 1);
          }
        }

        this.selectExMemory.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectExMemory.splice(findExMemory, 1);
      }
      console.log(this.selectExMemory);
    },
    funSelectScreen(val) {
      const findScreen = this.selectScreen.findIndex(element => element == val);

      console.log('findScreen = {}', findScreen);

      // 선택한 값이 없을 경우
      if (findScreen === -1) {
        // ALL일 경우
        if (val == this.screenTypes[0].value) {
          this.selectScreen.splice(0);
        } else {
          const findAllScreen = this.selectScreen.findIndex(
            element => element == this.screenTypes[0].value,
          );

          if (findAllScreen >= 0) {
            this.selectScreen.splice(findAllScreen, 1);
          }
        }

        this.selectScreen.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectScreen.splice(findScreen, 1);
      }
      console.log(this.selectScreen);
    },
    funSelectBattery(val) {
      const findBattery = this.selectBattery.findIndex(
        element => element == val,
      );

      console.log('findBattery = {}', findBattery);

      // 선택한 값이 없을 경우
      if (findBattery === -1) {
        // ALL일 경우
        if (val == this.batteryTypes[0].value) {
          this.selectBattery.splice(0);
        } else {
          const findAllBattery = this.selectBattery.findIndex(
            element => element == this.batteryTypes[0].value,
          );

          if (findAllBattery >= 0) {
            this.selectBattery.splice(findAllBattery, 1);
          }
        }

        this.selectBattery.push(val);
      } else {
        // 선택한 값이 있을 경우
        this.selectBattery.splice(findBattery, 1);
      }
      console.log(this.selectBattery);
    },
    tabSel(id) {
      // alert(id);
      let con_top_height = this.$refs.con_top.offsetHeight;
      let con_section_wrap_height = this.$refs.con_section_wrap.offsetHeight;
      let con_tab_1_height = this.$refs.tab_1.offsetHeight;
      let con_tab_2_height = this.$refs.tab_2.offsetHeight;
      let con_tab_3_height = this.$refs.tab_3.offsetHeight;
      let con_tab_4_height = this.$refs.tab_4.offsetHeight;
      let con_tab_5_height = this.$refs.tab_5.offsetHeight;
      let con_tab_6_height = this.$refs.tab_6.offsetHeight;
      let con_section_div_height = this.$refs.con_section_div.offsetHeight;

      console.log('con_top_height = ' + con_top_height);
      console.log('con_section_wrap_height = ' + con_section_wrap_height);
      console.log('con_tab_1_height = ' + con_tab_1_height);
      console.log('con_tab_2_height = ' + con_tab_2_height);
      console.log('con_tab_3_height = ' + con_tab_3_height);
      console.log('con_tab_4_height = ' + con_tab_4_height);
      console.log('con_tab_5_height = ' + con_tab_5_height);
      console.log('con_tab_6_height = ' + con_tab_6_height);
      console.log('con_section_div_height = ' + con_section_div_height);

      let classElement = document.querySelector('.tab_li.on');
      console.log(classElement);
      if (classElement !== null) {
        classElement.classList.remove('on');
      }

      if (id == 'tab_1') {
        document.querySelector('.con_tab_li').scroll({
          behavior: 'smooth',
          left: 0,
        });
        this.$refs.tab_1.scrollIntoView({ behavior: 'auto' });
      } else if (id == 'tab_2') {
        document.querySelector('.con_tab_li').scroll({
          behavior: 'smooth',
          left: 0,
        });
        // 지정한 px 만큼 scoll 추가 이동
        this.$refs.modal.scrollTo({
          top: con_tab_1_height - con_top_height,
          behavior: 'auto',
        });
        // this.$refs.tab_2.scrollIntoView({ behavior: 'auto' });
      } else if (id == 'tab_3') {
        document.querySelector('.con_tab_li').scroll({
          behavior: 'smooth',
          left: 0,
        });
        this.$refs.modal.scrollTo({
          top:
            con_tab_1_height +
            con_tab_2_height +
            con_section_div_height -
            con_top_height,
          behavior: 'auto',
        });
        // this.$refs.modal.scrollTo({ top: 395, behavior: 'auto' });
        // this.$refs.tab_3.scrollIntoView({ behavior: 'auto' });
      } else if (id == 'tab_4') {
        document.querySelector('.con_tab_li').scroll({
          behavior: 'smooth',
          left: 1000,
        });
        this.$refs.modal.scrollTo({
          top:
            con_tab_1_height +
            con_tab_2_height +
            con_tab_3_height +
            con_section_div_height * 2 -
            con_top_height,
          behavior: 'auto',
        });
        // this.$refs.modal.scrollTo({ top: 620, behavior: 'auto' });
        // this.$refs.tab_4.scrollIntoView({ behavior: 'auto' });
      } else if (id == 'tab_5') {
        document.querySelector('.con_tab_li').scroll({
          behavior: 'smooth',
          left: 1000,
        });
        this.$refs.modal.scrollTo({
          top:
            con_tab_1_height +
            con_tab_2_height +
            con_tab_3_height +
            con_tab_4_height +
            con_section_div_height * 3 -
            con_top_height,
          behavior: 'auto',
        });
        // this.$refs.modal.scrollTo({ top: 680, behavior: 'auto' });
        // this.$refs.tab_5.scrollIntoView({ behavior: 'auto' });
      } else if (id == 'tab_6') {
        document.querySelector('.con_tab_li').scroll({
          behavior: 'smooth',
          left: 1000,
        });
        this.$refs.modal.scrollTo({
          top:
            con_tab_1_height +
            con_tab_2_height +
            con_tab_3_height +
            con_tab_4_height +
            con_tab_5_height +
            con_section_div_height * 4 -
            con_top_height,
          behavior: 'auto',
        });
        // this.$refs.tab_6.scrollIntoView({ behavior: 'auto' });
      }

      let idElement = document.getElementById(id);
      idElement.classList.add('on');
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    onScroll(e) {
      let con_top_height = this.$refs.con_top.offsetHeight;
      let con_section_wrap_height = this.$refs.con_section_wrap.offsetHeight;
      let con_tab_1_height = this.$refs.tab_1.offsetHeight;
      let con_tab_2_height = this.$refs.tab_2.offsetHeight;
      let con_tab_3_height = this.$refs.tab_3.offsetHeight;
      let con_tab_4_height = this.$refs.tab_4.offsetHeight;
      let con_tab_5_height = this.$refs.tab_5.offsetHeight;
      let con_tab_6_height = this.$refs.tab_6.offsetHeight;
      let con_section_div_height = this.$refs.con_section_div.offsetHeight;
      let id = 'tab_1';

      const scroll = document.getElementById('filter_modal').scrollTop;
      // console.log('scroll = ' + scroll);

      if (
        con_tab_4_height +
          con_tab_3_height +
          con_tab_2_height +
          con_tab_1_height +
          con_section_div_height * 4 -
          con_top_height <=
        scroll
      ) {
        id = 'tab_6';
      } else if (
        con_tab_4_height +
          con_tab_3_height +
          con_tab_2_height +
          con_tab_1_height +
          con_section_div_height * 3 -
          con_top_height <=
        scroll
      ) {
        id = 'tab_5';
      } else if (
        con_tab_3_height +
          con_tab_2_height +
          con_tab_1_height +
          con_section_div_height * 2 -
          con_top_height <=
        scroll
      ) {
        id = 'tab_4';
      } else if (
        con_tab_2_height +
          con_tab_1_height +
          con_section_div_height -
          con_top_height <=
        scroll
      ) {
        id = 'tab_3';
      } else if (con_tab_1_height - con_top_height <= scroll) {
        id = 'tab_2';
      }

      const idElement = document.getElementById(id);
      const classElement = document.querySelector('.tab_li.on');
      classElement.classList.remove('on');
      idElement.classList.add('on');
    },
    bottomCheck(event) {
      const { scrollTop, offsetHeight, scrollHeight } = event.target;
      if (scrollTop + offsetHeight >= scrollHeight) {
        return true;
      }
    },
  },
};
</script>
<style lang="scss"></style>
